export const enSE = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Lassie",
  legalName: "Lassie AB",
  url: "https://www.lassie.co",
  logo: "https://www.lassie.co/images/logo-with-name.svg",
  description:
    "Sweden's leading pet insurance with top-rated terms, fast payouts, focus on preventive care and Sweden's most satisfied pet insurance customers 2024 (Swedish Quality Index)",
  email: "hej@lassie.co",
  telephone: "+46101839818",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Döbelnsgatan 21",
    postalCode: "111 40",
    addressLocality: "Stockholm",
    addressCountry: "SE",
  },
  sameAs: [
    "https://www.facebook.com/Lassie.Sweden",
    "https://www.instagram.com/lassie_se/",
    "https://www.youtube.com/@lassie_co",
    "https://www.linkedin.com/company/lassieco/",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Insurance",
    itemListElement: [
      {
        "@type": "OfferCatalog",
        name: "Dog Insurance",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Insurance Bronze",
              description:
                "Veterinary care insurance for dogs with maximum coverage of 30,000 SEK per insurance year. Covers veterinary costs when your dog needs care.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Insurance Silver",
              description:
                "Veterinary care insurance for dogs with maximum coverage of 60,000-120,000 SEK per insurance year. Covers medicine, rehabilitation, food, advanced diagnostics and milk teeth.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dog Insurance Gold",
              description:
                "Comprehensive veterinary care insurance for dogs with maximum coverage of 160,000 SEK per insurance year. Covers medicine, rehabilitation, food, advanced diagnostics and milk teeth.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=dog",
              },
            ],
          },
        ],
      },
      {
        "@type": "OfferCatalog",
        name: "Cat Insurance",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Cat Insurance Bronze",
              description:
                "Veterinary care insurance for cats with maximum coverage of 30,000 SEK per insurance year. Covers veterinary costs when your cat needs care.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Cat Insurance Silver",
              description:
                "Veterinary care insurance for cats with maximum coverage of 60,000-120,000 SEK per insurance year. Covers medicine, rehabilitation, food, advanced diagnostics and milk teeth.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Cat Insurance Gold",
              description:
                "Comprehensive veterinary care insurance for cats with maximum coverage of 160,000 SEK per insurance year. Covers medicine, rehabilitation, food, advanced diagnostics and milk teeth.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=cat",
              },
            ],
          },
        ],
      },
      {
        "@type": "OfferCatalog",
        name: "Breeder Insurance",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Breeder Insurance for Dogs",
              description:
                "Additional insurance for breeders that includes puppy litter insurance, hidden defects insurance, cesarean section and fertility examination. Costs 200 SEK/year.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Breeder Insurance for Cats",
              description:
                "Additional insurance for breeders that includes kitten litter insurance, hidden defects insurance, cesarean section and fertility examination. Costs 100 SEK/year.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://www.lassie.co/signup/?species=cat",
              },
            ],
          },
        ],
      },
    ],
  },
};
